import { render } from "./AdvertForecasting.vue?vue&type=template&id=16d18ee0"
import script from "./AdvertForecasting.vue?vue&type=script&lang=js"
export * from "./AdvertForecasting.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__